import Label from './label.element.js';

export default Label;

Label.define('wje-label', Label);
